import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import quizApp from './reducers/quizApp'
//import 'semantic-ui-css/semantic.min.css'
import './theme/semantic.less'
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import socketHandler from './listeners/socket'
import { registerSocket } from './reducers/actions'
import { newVersionDownloaded } from './reducers/newVersion'
import KitchenSink from './components/KitchenSink'
import getDummyState from './utils/dummyState'
import './index.css'

const params = window.location.search.substr(1)
    .split('&')
    .map(e => e.split('='))
    .reduce((p, [n, v]) => {
        p[decodeURIComponent(n)] = decodeURIComponent(v)
        return p
    }, {})

const store = createStore(quizApp, { ...getDummyState(params.s), resetPasswordToken: params.resetToken })
if (params.resetToken && window.history.replaceState) {
    // remove token from browser URL for security reasons
    window.history.replaceState({}, document.title, window.location.href.replace(/resetToken=[^&]*/, '').replace('&&', '&'));
}
store.dispatch(registerSocket((window.io && window.io()) || { on: () => {}, emit: (event, ...params) => console.log('fakeEmit', event, params) }))

socketHandler(store)

ReactDOM.render(
    <Provider store={store}>
        {params.hasOwnProperty('kitchensink') ? <KitchenSink /> : <App />}
    </Provider>,
    document.getElementById('root')
);

// registerServiceWorker(() => store.dispatch(newVersionDownloaded()));

// Remove service worker and reload the page in case there was a registered service worker, to load the fresher app
unregister().then(wasRegistered => wasRegistered && window.location.reload());




// WEBPACK FOOTER //
// ./src/index.js